import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.css']
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
  }

  goToWebsite(){
    window.open('https://www.voyjaleas.com', '_blank');
  }

}
